{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "Izvēlētas {conversationCount} sarunas",
    "NONE": "Nav",
    "CLEAR_SELECTION": "Notīrīt",
    "ASSIGN_AGENT_CONFIRMATION_LABEL": "Are you sure you want to assign {n} conversation to {agentName}? | Are you sure you want to assign {n} conversations to {agentName}?",
    "UNASSIGN_AGENT_CONFIRMATION_LABEL": "Are you sure you want to unassign {n} conversation? | Are you sure you want to unassign {n} conversations?",
    "YES": "Jā",
    "CANCEL": "Atcelt",
    "SEARCH_INPUT_PLACEHOLDER": "Meklēt",
    "ASSIGN_AGENT_TOOLTIP": "Piešķirt aģentu",
    "ASSIGN_TEAM_TOOLTIP": "Piešķirt komandu",
    "ASSIGN_SUCCESFUL": "Sarunas ir veiksmīgi piešķirtas.",
    "ASSIGN_FAILED": "Neizdevās piešķirt sarunas. Lūdzu mēģiniet vēlreiz.",
    "RESOLVE_SUCCESFUL": "Sarunas ir veiksmīgi atrisinātas.",
    "RESOLVE_FAILED": "Neizdevās atrisināt sarunas. Lūdzu mēģiniet vēlreiz.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Šajā lapā redzamās sarunas ir tikai izvēlētas.",
    "UPDATE": {
      "CHANGE_STATUS": "Mainīt statusu",
      "SNOOZE_UNTIL": "Atlikt",
      "UPDATE_SUCCESFUL": "Sarunas statuss ir veiksmīgi atjaunināts.",
      "UPDATE_FAILED": "Neizdevās atjaunināt sarunas. Lūdzu mēģiniet vēlreiz."
    },
    "RESOLVE": {
      "ALL_MISSING_ATTRIBUTES": "Cannot resolve conversations due to missing required attributes",
      "PARTIAL_SUCCESS": "Some conversations need required attributes before resolving and were skipped"
    },
    "LABELS": {
      "ASSIGN_LABELS": "Piešķirt etiķetes",
      "REMOVE_LABELS": "Remove labels",
      "ASSIGN_SELECTED_LABELS": "Piešķirt izvēlētās etiķetes",
      "REMOVE_SELECTED_LABELS": "Remove selected labels",
      "ASSIGN_SUCCESFUL": "Etiķetes ir veiksmīgi piešķirtas.",
      "ASSIGN_FAILED": "Neizdevās piešķirt etiķetes. Lūdzu mēģiniet vēlreiz.",
      "REMOVE_SUCCESFUL": "Labels removed successfully.",
      "REMOVE_FAILED": "Failed to remove labels. Please try again."
    },
    "TEAMS": {
      "NONE": "Nav",
      "ASSIGN_TEAM_CONFIRMATION_LABEL": "Are you sure you want to assign {n} conversation to {teamName}? | Are you sure you want to assign {n} conversations to {teamName}?",
      "UNASSIGN_TEAM_CONFIRMATION_LABEL": "Are you sure you want to unassign {n} conversation? | Are you sure you want to unassign {n} conversations?",
      "ASSIGN_SUCCESFUL": "Komandas ir veiksmīgi piešķirtas.",
      "ASSIGN_FAILED": "Neizdevās piešķirt komandu. Lūdzu mēģiniet vēlreiz."
    }
  }
}
